/**
 * Mount-once component that records tenant page views. Renders nothing; place it
 * inside the authenticated tenant shell (e.g. alongside the routed `<Outlet />`).
 */

import { usePageViewTracking } from '../hooks/usePageViewTracking'

export default function AnalyticsTracker() {
  usePageViewTracking()
  return null
}
